import { render, staticRenderFns } from "./UnidadeParceiraForm.vue?vue&type=template&id=454f025b"
import script from "./UnidadeParceiraForm.vue?vue&type=script&lang=js"
export * from "./UnidadeParceiraForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports